// Clicking inside popovers should never close Unpoly modals
up.on('click', '.popover', (event) => { event.preventDefault() })
